module.exports = __webpack_public_path__ + "static/fonts/AkkuratPro-Bold.4b356bb.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/AkkuratPro-Bold.eot
// module id = cydc
// module chunks = 1